export default "__VITE_ASSET__VERZCfff__"